var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
import { createAction } from "redux-act";
import { createCustomAction, EActionState } from "../utils/action.utils";
import { GENERATOR_PARAMS } from "./auth.constants";
var EActionCustom;
(function (EActionCustom) {
    EActionCustom["AuthSetBypassToken"] = "AUTH_SET_BYPASS_TOKEN";
    EActionCustom["AuthSignIn"] = "AUTH_SIGN_IN";
    EActionCustom["AuthSignInAutomatically"] = "AUTH_SIGN_IN_AUTOMATICALLY";
    EActionCustom["AuthSetSelectedDashboard"] = "AUTH_SET_SELECTED_DASHBOARD";
    EActionCustom["SetAccessTokensWithoutSideEffects"] = "SET_ACCESS_TOKENS_WITHOUT_SIDE_EFFECTS";
    EActionCustom["AuthRefreshSuccess"] = "AUTH_REFRESH_SUCCESS";
    EActionCustom["AuthSignOut"] = "AUTH_SIGN_OUT";
    EActionCustom["AuthSignUp"] = "AUTH_SIGN_UP";
    EActionCustom["AuthSignUpVerifyPhone"] = "AUTH_SIGN_UP_VERIFY_PHONE";
    EActionCustom["AuthSignUpVerifyEmail"] = "AUTH_SIGN_UP_VERIFY_EMAIL";
    EActionCustom["AuthSignUpRequestTokenFromEmail"] = "AUTH_SIGN_UP_REQUEST_TOKEN_FROM_EMAIL";
    EActionCustom["AuthSignUpResendVerificationEmail"] = "AUTH_SIGN_UP_RESEND_VERIFICATION_EMAIL";
    EActionCustom["AuthSignUpResendVerificationSms"] = "AUTH_SIGN_UP_RESEND_VERIFICATION_SMS";
    EActionCustom["AuthUerUpdate"] = "AUTH_USER_UPDATE";
    EActionCustom["AuthUserUpdateById"] = "AUTH_USER_UPDATE_BY_ID";
    EActionCustom["AuthAdminVerifyEmail"] = "AUTH_ADMIN_VERIFY_EMAIL";
    EActionCustom["AuthAdminVerifyPhone"] = "AUTH_ADMIN_VERIFY_PHONE";
    EActionCustom["AuthUserRemoveProfile"] = "AUTH_USER_REMOVE_PROFILE";
    EActionCustom["GetUser"] = "AUTH_USER_GET";
})(EActionCustom || (EActionCustom = {}));
export var setBypassToken = createAction("SET_BYPASS_TOKEN");
var generateSignInActions = function () { return ({
    signInStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignIn,
        state: EActionState.Start,
    }),
    signInSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignIn,
        state: EActionState.Success,
    }),
    signInFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignIn,
        state: EActionState.Fail,
    }),
}); };
var generateSignInAutomaticallyActions = function () { return ({
    signInAutomaticallyStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignInAutomatically,
        state: EActionState.Start,
    }),
    signInAutomaticallySucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignInAutomatically,
        state: EActionState.Success,
    }),
    signInAutomaticallyFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignInAutomatically,
        state: EActionState.Fail,
    }),
}); };
var generateSetSelectedDashboardActions = function () { return ({
    setSelectedDashboardStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSetSelectedDashboard,
        state: EActionState.Start,
    }),
    setSelectedDashboardSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSetSelectedDashboard,
        state: EActionState.Success,
    }),
    setSelectedDashboardFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSetSelectedDashboard,
        state: EActionState.Fail,
    }),
}); };
var generateSetAccessTokensWithoutSideEffectsActions = function () { return ({
    setAccessTokensWithoutSideEffectsStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.SetAccessTokensWithoutSideEffects,
        state: EActionState.Start,
    }),
    setAccessTokensWithoutSideEffectsSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.SetAccessTokensWithoutSideEffects,
        state: EActionState.Success,
    }),
    setAccessTokensWithoutSideEffectsFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.SetAccessTokensWithoutSideEffects,
        state: EActionState.Fail,
    }),
}); };
var generateRefreshSuccessActions = function () { return ({
    refreshSuccessStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthRefreshSuccess,
        state: EActionState.Start,
    }),
    refreshSuccessSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthRefreshSuccess,
        state: EActionState.Success,
    }),
    refreshSuccessFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthRefreshSuccess,
        state: EActionState.Fail,
    }),
}); };
var generateSignOutActions = function () { return ({
    signOutStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignOut,
        state: EActionState.Start,
    }),
    signOutSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignOut,
        state: EActionState.Success,
    }),
    signOutFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignOut,
        state: EActionState.Fail,
    }),
}); };
var generateSignUpVerifyPhoneActions = function () { return ({
    signUpVerifyPhoneStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignUpVerifyPhone,
        state: EActionState.Start,
    }),
    signUpVerifyPhoneSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignUpVerifyPhone,
        state: EActionState.Success,
    }),
    signUpVerifyPhoneFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignUpVerifyPhone,
        state: EActionState.Fail,
    }),
}); };
var generateGetUserActions = function () { return ({
    getUserStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.GetUser,
        state: EActionState.Start,
    }),
    getUserSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.GetUser,
        state: EActionState.Success,
    }),
    getUserFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.GetUser,
        state: EActionState.Fail,
    }),
}); };
var generateSignUpActions = function () { return ({
    signUpStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignUp,
        state: EActionState.Start,
    }),
    signUpSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignUp,
        state: EActionState.Success,
    }),
    signUpFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignUp,
        state: EActionState.Fail,
    }),
}); };
var generateSignUpVerifyEmailActions = function () { return ({
    signUpVerifyEmailStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignUpVerifyEmail,
        state: EActionState.Start,
    }),
    signUpVerifyEmailSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignUpVerifyEmail,
        state: EActionState.Success,
    }),
    signUpVerifyEmailFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignUpVerifyEmail,
        state: EActionState.Fail,
    }),
}); };
var generateSignUpRequestTokenFromEmailActions = function () { return ({
    signUpRequestTokenFromEmailStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignUpRequestTokenFromEmail,
        state: EActionState.Start,
    }),
    signUpRequestTokenFromEmailSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignUpRequestTokenFromEmail,
        state: EActionState.Success,
    }),
    signUpRequestTokenFromEmailFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignUpRequestTokenFromEmail,
        state: EActionState.Fail,
    }),
}); };
var generateSignUpResendVerificationEmailActions = function () { return ({
    signUpResendVerificationEmailStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignUpResendVerificationEmail,
        state: EActionState.Start,
    }),
    signUpResendVerificationEmailSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignUpResendVerificationEmail,
        state: EActionState.Success,
    }),
    signUpResendVerificationEmailFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignUpResendVerificationEmail,
        state: EActionState.Fail,
    }),
}); };
var generateSignUpResendVerificationSmsActions = function () { return ({
    signUpResendVerificationSmsStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignUpResendVerificationSms,
        state: EActionState.Start,
    }),
    signUpResendVerificationSmsSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignUpResendVerificationSms,
        state: EActionState.Success,
    }),
    signUpResendVerificationSmsFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignUpResendVerificationSms,
        state: EActionState.Fail,
    }),
}); };
var generateUpdateUserActions = function () { return ({
    updateUserStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthUerUpdate,
        state: EActionState.Start,
    }),
    updateUserSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthUerUpdate,
        state: EActionState.Success,
    }),
    updateUserFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthUerUpdate,
        state: EActionState.Fail,
    }),
}); };
var generateUpdateUserByIdActions = function () { return ({
    updateUserByIdStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthUserUpdateById,
        state: EActionState.Start,
    }),
    updateUserByIdSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthUserUpdateById,
        state: EActionState.Success,
    }),
    updateUserByIdFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthUserUpdateById,
        state: EActionState.Fail,
    }),
}); };
var generateAdminVerifyEmailActions = function () { return ({
    adminVerifyEmailStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthAdminVerifyEmail,
        state: EActionState.Start,
    }),
    adminVerifyEmailSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthAdminVerifyEmail,
        state: EActionState.Success,
    }),
    adminVerifyEmailFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthAdminVerifyEmail,
        state: EActionState.Fail,
    }),
}); };
var generateAdminVerifyPhoneActions = function () { return ({
    adminVerifyPhoneStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthAdminVerifyPhone,
        state: EActionState.Start,
    }),
    adminVerifyPhoneSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthAdminVerifyPhone,
        state: EActionState.Success,
    }),
    adminVerifyPhoneFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthAdminVerifyPhone,
        state: EActionState.Fail,
    }),
}); };
var generateRemoveProfileActions = function () { return ({
    removeProfileStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthUserRemoveProfile,
        state: EActionState.Start,
    }),
    removeProfileSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthUserRemoveProfile,
        state: EActionState.Success,
    }),
    removeProfileFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthUserRemoveProfile,
        state: EActionState.Fail,
    }),
}); };
export var signInStart = (_a = generateSignInActions(), _a.signInStart), signInSucceeded = _a.signInSucceeded, signInFailed = _a.signInFailed;
export var signOutStart = (_b = generateSignOutActions(), _b.signOutStart), signOutSucceeded = _b.signOutSucceeded, signOutFailed = _b.signOutFailed;
export var signInAutomaticallyStart = (_c = generateSignInAutomaticallyActions(), _c.signInAutomaticallyStart), signInAutomaticallySucceeded = _c.signInAutomaticallySucceeded, signInAutomaticallyFailed = _c.signInAutomaticallyFailed;
export var setSelectedDashboardStart = (_d = generateSetSelectedDashboardActions(), _d.setSelectedDashboardStart), setSelectedDashboardSucceeded = _d.setSelectedDashboardSucceeded, setSelectedDashboardFailed = _d.setSelectedDashboardFailed;
export var setAccessTokensWithoutSideEffectsStart = (_e = generateSetAccessTokensWithoutSideEffectsActions(), _e.setAccessTokensWithoutSideEffectsStart), setAccessTokensWithoutSideEffectsSucceeded = _e.setAccessTokensWithoutSideEffectsSucceeded, setAccessTokensWithoutSideEffectsFailed = _e.setAccessTokensWithoutSideEffectsFailed;
export var refreshSuccessStart = (_f = generateRefreshSuccessActions(), _f.refreshSuccessStart), refreshSuccessSucceeded = _f.refreshSuccessSucceeded, refreshSuccessFailed = _f.refreshSuccessFailed;
export var signUpVerifyPhoneStart = (_g = generateSignUpVerifyPhoneActions(), _g.signUpVerifyPhoneStart), signUpVerifyPhoneSucceeded = _g.signUpVerifyPhoneSucceeded, signUpVerifyPhoneFailed = _g.signUpVerifyPhoneFailed;
export var getUserStart = (_h = generateGetUserActions(), _h.getUserStart), getUserSucceeded = _h.getUserSucceeded, getUserFailed = _h.getUserFailed;
export var signUpStart = (_j = generateSignUpActions(), _j.signUpStart), signUpSucceeded = _j.signUpSucceeded, signUpFailed = _j.signUpFailed;
export var signUpVerifyEmailStart = (_k = generateSignUpVerifyEmailActions(), _k.signUpVerifyEmailStart), signUpVerifyEmailSucceeded = _k.signUpVerifyEmailSucceeded, signUpVerifyEmailFailed = _k.signUpVerifyEmailFailed;
export var signUpRequestTokenFromEmailStart = (_l = generateSignUpRequestTokenFromEmailActions(), _l.signUpRequestTokenFromEmailStart), signUpRequestTokenFromEmailSucceeded = _l.signUpRequestTokenFromEmailSucceeded, signUpRequestTokenFromEmailFailed = _l.signUpRequestTokenFromEmailFailed;
export var signUpResendVerificationEmailStart = (_m = generateSignUpResendVerificationEmailActions(), _m.signUpResendVerificationEmailStart), signUpResendVerificationEmailSucceeded = _m.signUpResendVerificationEmailSucceeded, signUpResendVerificationEmailFailed = _m.signUpResendVerificationEmailFailed;
export var signUpResendVerificationSmsStart = (_o = generateSignUpResendVerificationSmsActions(), _o.signUpResendVerificationSmsStart), signUpResendVerificationSmsSucceeded = _o.signUpResendVerificationSmsSucceeded, signUpResendVerificationSmsFailed = _o.signUpResendVerificationSmsFailed;
export var updateUserStart = (_p = generateUpdateUserActions(), _p.updateUserStart), updateUserSucceeded = _p.updateUserSucceeded, updateUserFailed = _p.updateUserFailed;
export var updateUserByIdStart = (_q = generateUpdateUserByIdActions(), _q.updateUserByIdStart), updateUserByIdSucceeded = _q.updateUserByIdSucceeded, updateUserByIdFailed = _q.updateUserByIdFailed;
export var adminVerifyEmailStart = (_r = generateAdminVerifyEmailActions(), _r.adminVerifyEmailStart), adminVerifyEmailSucceeded = _r.adminVerifyEmailSucceeded, adminVerifyEmailFailed = _r.adminVerifyEmailFailed;
export var adminVerifyPhoneStart = (_s = generateAdminVerifyPhoneActions(), _s.adminVerifyPhoneStart), adminVerifyPhoneSucceeded = _s.adminVerifyPhoneSucceeded, adminVerifyPhoneFailed = _s.adminVerifyPhoneFailed;
export var removeProfileStart = (_t = generateRemoveProfileActions(), _t.removeProfileStart), removeProfileSucceeded = _t.removeProfileSucceeded, removeProfileFailed = _t.removeProfileFailed;
